export enum DateFormat {
  Default = 'DD/MM/YYYY',
  ISO = 'YYYY-MM-DD',
}
